import React, { useState } from 'react'
import { SelectLocationLogEntryTypeModal } from '@src/modules/Locations/components/ViewLocation/components/LocationLogs/EntriesTab/components/SelectLocationLogEntryTypeModal'
import { EntryFormModal } from '@src/modules/Locations/components/ViewLocation/components/LocationLogs/EntriesTab/components/EntryFormModal'
import { stringOrUndefined } from '@src/utils/strings'
import {
  LocationContextProvider,
  useLocation,
  useLocationContext,
} from '@therms/react-modules'

interface SelectLogEntryAndFormModalContentProps {
  closeHandler: () => void
  onLogEntryComplete: () => void
}

function SelectLogEntryAndFormModalContent({
  closeHandler,
  onLogEntryComplete,
}: SelectLogEntryAndFormModalContentProps) {
  const [selectedEntryTypeId, setSelectedEntryTypeId] = useState('')
  const [selectedEntryTypeName, setSelectedEntryTypeName] = useState('')

  const locationContext = useLocationContext(true)

  const closeModal = () => {
    setSelectedEntryTypeName('')
    setSelectedEntryTypeId('')
    closeHandler()
  }

  if (selectedEntryTypeId)
    return (
      <EntryFormModal
        closeHandler={closeModal}
        entryTypeId={stringOrUndefined(selectedEntryTypeId)}
        entryTypeName={stringOrUndefined(selectedEntryTypeName)}
        onComplete={onLogEntryComplete}
      />
    )

  if (!selectedEntryTypeId)
    return (
      <SelectLocationLogEntryTypeModal
        closeHandler={closeModal}
        entryTypeIds={
          locationContext.location.config?.log?.allowedEntryTypeIds ?? []
        }
        onSelectEntryType={(id, name) => {
          setSelectedEntryTypeId(id)
          setSelectedEntryTypeName(name)
        }}
      />
    )
}

interface SelectLogEntryAndFormModalProps
  extends SelectLogEntryAndFormModalContentProps {
  locationId: string
}

function SelectLogEntryAndFormModal({
  closeHandler,
  locationId,
  onLogEntryComplete,
}: SelectLogEntryAndFormModalProps) {
  return (
    <LocationContextProvider locationId={locationId}>
      <SelectLogEntryAndFormModalContent
        closeHandler={closeHandler}
        onLogEntryComplete={onLogEntryComplete}
      />
    </LocationContextProvider>
  )
}

export { SelectLogEntryAndFormModal }
